const url = require('./dev.uri').BASE_URI;

module.exports = {
  [url]: {
    // target: 'http://localhost:48080',
    // target:'https://elderlycare.ndlink.cn',
    target:'https://casmce.ndlink.cn',
    changeOrigin: true,
    pathRewrite: {
      ['^' + url]: ''
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/proxy-mock.js
// module id = J+A6
// module chunks = 285